import React from "react";
import b2Image from "../assets/about_bunny.png";

const AboutB2Section = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

        .b2-section {
          max-width: 80rem;
          margin: 0 auto;
          min-height: 650px;
          font-family: 'Poppins', sans-serif;
          background: #FEFEFD;
background: radial-gradient(circle, rgb(251 251 248) 0%, rgba(254, 254, 254, 1) 50%, rgba(255, 255, 255, 1) 100%);
          display: grid;
          grid-template-columns: 1fr 1fr;
          align-items: center;
          gap: 40px;
          padding: 0px 32px;
          margin-top: 64px;
          // margin-bottom: 64px;
          box-sizing: border-box;
        }

        .b2-content {
    max-width: 520px;
    margin: 0 auto;
    text-align: center;
}

        .about-label {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  text-transform: uppercase;

  background: linear-gradient(
    135deg,
    #129ADC,
    #B55DD0,
    #E154AA,
    #F45A39
  );

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  margin: 0 auto 10px;
  width: fit-content;
}

        .b2-heading {
          font-size: 36px;
          font-weight: 700;
          color: #111827;
          line-height: 52px;
          margin: 0 0 24px;
        }

        .b2-para {
          font-size: 0.95rem;
          font-weight: 400;
          color: #181818;
          line-height: 1.8;
          margin: 0 0 18px;
          text-align: justify;
        }

        .b2-image-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .b2-image {
          width: 100%;
          max-width: 600px;
          height: auto;
          object-fit: contain;
        }

        /* Tablet */
        @media (max-width: 992px) {
          .b2-section {
            grid-template-columns: 1fr;
            padding: 50px 40px;
            gap: 30px;
            text-align: center;
          }

          .b2-content {
            max-width: 100%;
          }

          .b2-para {
            text-align: center;
          }
        }

        /* Mobile */
        @media (max-width: 576px) {
          .b2-section {
            padding: 40px 20px;
          }

         

          .b2-para {
            font-size: 0.9rem;
          }

          .b2-image {
            max-width: 100%;
          }
        }
      `}</style>

      <section className="b2-section">
        {/* Left Content */}
        <div className="b2-content">
          <p className="about-label">ABOUT B2</p>

          <h2 className="b2-heading">
            Cute outside <br />
            Strategy inside.
          </h2>

          <p className="b2-para">
            B2 is the mascot of SINTX, representing creativity, clarity,
            and communication in design. He brings ideas to life visually
            and adds personality to the brand.
          </p>

          <p className="b2-para">
            The name B2 is derived from rabbit → bit → bitu → B2. In
            digital terms, a "bit" is the smallest unit, symbolizing how
            even small design details can create a big impact.
          </p>

          <p className="b2-para">
            B2 is designed to be clean, friendly, and adaptable —
            reflecting modern design and evolving with different stages
            of a brand, from idea to growth.
          </p>
        </div>

        {/* Right Image */}
        <div className="b2-image-wrapper">
          <img
            src={b2Image}
            alt="B2 mascot"
            className="b2-image"
          />
        </div>
      </section>
    </>
  );
};

export default AboutB2Section;